module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sucess"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('Icon', {
    attrs: {
      "type": "checkmark-round"
    }
  }), _vm._v(" Success")], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_vm._v("Your abstract is submitted successfully")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "btm"
    },
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_vm._v("Check   status")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64a3b15f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paper/Success.vue
// module id = 809
// module chunks = 10